<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33" v-for="transaction in transactionList">
				<stats-card data-background-color="orange">
					<template slot="content">
						<p class="category">
						<table style="width: 100%">
							<tr>
								<td>លេខកូដ</td>
								<td style="width: 20px">:</td>
								<td>{{transaction.hash_id}}</td>
							</tr>
							<tr>
								<td>ចំនួនទូទាត់</td>
								<td>:</td>
								<td><b>{{config.moneylify(transaction.total_usd)}} និង {{config.moneylify(transaction.total_khr, 'khr')}}</b></td>
							</tr>
							<tr>
								<td>ថ្ងៃបានទូទាត់</td>
								<td>:</td>
								<td>{{config.datelify(transaction.created_date)}}</td>
							</tr>
						</table>

						</p>
						<p style="text-align: right;">
							<!-- <span style="text-align: right;" class="late" v-if="payment.status == 'wdv'">រង់ចាំអ្នកដឹកជញ្ជូន</span>
							<span style="text-align: right;" class="neutral" v-if="payment.status == 'dvr'">កំពុងដឹកជញ្ជូន</span> -->
							<span style="text-align: right; cursor: pointer;" class="active" @click="view(transaction.hash_id)">មើលលម្អិត</span>
						</p>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 text-center"
				v-if="loaded && transactionList.length == 0">
				<h4>អ្នកមិនទាន់មានប្រតិបត្តិការទេ</h4>
			</div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 text-center">
				<div class="places-buttons text-center" v-if="loadMore">
					<md-button class="md-primary" @click="getTransaction(true)">បង្ហាញបន្ថែម</md-button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'

	export default {
		components: {
			StatsCard
		},
		data() {
			return {
				loaded: false,
				loadMore: false,
				transactionList: [],
			}
		},

		created() {
			this.getTransaction();
		},
		computed: {

		},
		methods: {
			view(hash_id) {
				this.$router.push("/transactions/" + hash_id);
			},
			getTransaction(more = false) {
				let offset = more ? this.transactionList.length : 0

				this.$http.get(this.config.api + "/client/transaction/get/list/" + offset).then(data => {
					this.loaded = true
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.transactionList = more ? this.transactionList.concat(data.body.data) : data.body.data;
				});
			},

		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Transactions.vue